import { getUserConfig } from '../api/modules/misc';/**
 * 规范化布局模式值，仅允许 classic / portal
 * @param {*} val
 * @returns {string} 合法模式或空串
 */
export function normalizeLayoutMode(val) {
  const mode = (val || '').toString().trim()
  return (mode === 'classic' || mode === 'portal') ? mode : ''
}

/**
 * 从云端按用户拉取布局偏好并写入 Vuex / localStorage。
 * 换电脑登录时依赖此方法「取回」SaveConfig 已写入的 layout。
 * @param {number|string} userId 登录用户 uID
 * @param {import('vuex').Store} vueStore Vuex store 实例
 * @returns {Promise<{ mode: string, changed: boolean }>}
 */
export async function fetchAndApplyUserLayout(userId, vueStore) {
  const uid = Number(userId) || 0
  const current = (vueStore && vueStore.state && vueStore.state.sysLayoutMode) || 'classic'
  if (uid <= 0 || !vueStore) {
    return { mode: current, changed: false }
  }

  try {
    const res = await getUserConfig({ key: 'layout', userId: uid })
    const cloudMode = normalizeLayoutMode(res && res.data && res.data.response)
    if (!cloudMode) {
      return { mode: current, changed: false }
    }
    const changed = current !== cloudMode
    if (changed) {
      vueStore.commit('saveLayoutMode', cloudMode)
    }
    return { mode: cloudMode, changed }
  } catch (e) {
    console.warn('拉取云端布局失败，沿用本地', e)
    return { mode: current, changed: false }
  }
}
